// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContentSectionEditPageProduct.css
   ─────────────────────────────────────────────────────────────────────────────
   Scoped with scl--cms-content-edit-product- prefix to avoid collision with the generic cse- page.
   ───────────────────────────────────────────────────────────────────────────── */

/* ─── Root ─────────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-root {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

/* ─── Skeleton loading ──────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-skeleton-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}

@keyframes scl--cms-content-edit-product-shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position:   0% 50%; }
}

.scl--cms-content-edit-product-skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);
  background-size: 400% 100%;
  animation: scl--cms-content-edit-product-shimmer 1.4s ease infinite;
}
.scl--cms-content-edit-product-skeleton--title { height: 40px; width: 280px; }
.scl--cms-content-edit-product-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }
.scl--cms-content-edit-product-skeleton--field { height: 44px; width: 100%; }

/* ─── Empty state ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 8px;
  text-align: center;
}
.scl--cms-content-edit-product-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }
.scl--cms-content-edit-product-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }

/* ─── Page heading ──────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-page-title {
  margin: 0 0 6px;
  font-size: 36px;
  font-weight: 600;
  line-height: 40px;
  color: #323539;
}
.scl--cms-content-edit-product-page-desc {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 24px;
  color: #8A8B8F;
  letter-spacing: -0.01em;
}

/* ─── Meta grid (Section ID / Author / Section / Title / Status) ────────────── */
.scl--cms-content-edit-product-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  margin-bottom: 32px;
}
/* Status is 5th child — keep it in left column */
.scl--cms-content-edit-product-meta-grid > *:nth-child(5) { grid-column: 1; }

/* ─── Section editor wrapper ────────────────────────────────────────────────── */
.scl--cms-content-edit-product-section-editor {
  overflow: visible;
  position: relative;
}

.scl--cms-content-edit-product-section-heading {
  font-size: 16px;
  font-weight: 600;
  color: #323539;
  margin: 0 0 10px;
}

.scl--cms-content-edit-product-divider {
  height: 1px;
  background: #E1E4ED;
  margin-bottom: 20px;
}

/* ─── Field label row ───────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 8px;
}
.scl--cms-content-edit-product-label    { font-size: 14px; color: #323539; font-weight: 400; }
.scl--cms-content-edit-product-required { color: #FF4D4F; }

/* ─── SplitRow ──────────────────────────────────────────────────────────────── */
/*
  ┌─────────────────────────────────────────────────────────────┐
  │ ▌  saved / current text (left)   │  [input slot] (right)    │
  └─────────────────────────────────────────────────────────────┘
*/
.scl--cms-content-edit-product-split-row {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 60px;
  background: #FDFDFD;
  border: 1px dashed rgba(208, 213, 221, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.scl--cms-content-edit-product-split-row--multiline {
  min-height: 96px;
  align-items: flex-start;
}

/* Green left accent bar */
.scl--cms-content-edit-product-split-accent {
  width: 4px;
  flex-shrink: 0;
  background: #84A578;
  border-radius: 0 0 2px 2px;
  align-self: stretch;
}

/* Row body */
.scl--cms-content-edit-product-split-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 16px;
  gap: 12px;
  min-height: 60px;
}

.scl--cms-content-edit-product-split-row--multiline .scl--cms-content-edit-product-split-body {
  align-items: flex-start;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 96px;
}

/* Current / saved value — left side */
.scl--cms-content-edit-product-split-current {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  word-break: break-word;
}

/* Input component slot — right side */
.scl--cms-content-edit-product-split-slot {
  flex-shrink: 0;
  width: 240px;
}

/* TextField / TextArea component containers fill the slot */
.scl--cms-content-edit-product-split-slot .scl--cms-components-textField-container,
.scl--cms-content-edit-product-split-slot .scl--cms-components-textArea-container {
  width: 100%;
}

/* Textarea slot — fixed 351px width, scrollable */
.scl--cms-content-edit-product-split-slot--textarea {
  width: 351px;
}
.scl--cms-content-edit-product-split-slot--textarea .scl--cms-components-textArea-container,
.scl--cms-content-edit-product-split-slot--textarea .scl--cms-components-textArea-plate,
.scl--cms-content-edit-product-split-slot--textarea textarea {
  box-sizing: border-box;
}
.scl--cms-content-edit-product-split-slot--textarea textarea {
  max-height: 96px;
  overflow-y: auto;
  resize: none;
}

/* ─── Card / Product selector row ───────────────────────────────────────────── */
.scl--cms-content-edit-product-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  z-index: 10;
  margin-top: 16px;
  margin-bottom: 12px;
  gap: 12px;
}

/* Label on the left — takes remaining space */
.scl--cms-content-edit-product-card-row > .scl--cms-content-edit-product-label {
  flex: 1;
  min-width: 0;
}

.scl--cms-content-edit-product-card-row-right {
  display: flex;
  align-items: center; /* <-- vertical alignment */
  gap: 10px;
  flex-shrink: 0;
  overflow: visible;
  position: relative;
  z-index: 10;
}

/* SelectField — fixed width so it doesn't push the Toggle off */
.scl--cms-content-edit-product-card-select,
.scl--cms-content-edit-product-card-select .scl--cms-components-selectFieldInline-container {
  width: 220px;
  min-width: 0;
  flex-shrink: 0;
}

/* Toggle — never shrinks, always visible */
.scl--cms-content-edit-product-card-row-right > *:last-child {
  flex-shrink: 0;
  flex-grow: 0;
}

/* SelectField dropdown renders above everything */
.scl--cms-content-edit-product-card-select .scl--cms-components-selectFieldInline-dropdown,
.scl--cms-content-edit-product-card-select [class*="dropdown"],
.scl--cms-content-edit-product-card-select [class*="menu"] {
  z-index: 9999;
  position: absolute;
}

.scl--cms-content-edit-product-upload-block {
  margin-bottom: 4px;
}

/* Outer container — single dashed border, space-between, vertical divider via ::after */
.scl--cms-content-edit-product-upload-row {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  min-height: 128px;
  box-sizing: border-box;
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
}

/* Vertical divider line drawn at the center */
.scl--cms-content-edit-product-upload-row::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  background: rgba(229, 229, 231, 0.5);
  pointer-events: none;
}

/* ── Left panel: file preview ────────────────────────────────────────────────── */
.scl--cms-content-edit-product-upload-preview {
  box-sizing: border-box;
  position: relative;
  width: 50%;
  display: flex;
  align-items: flex-start;
  background: transparent;
  flex-shrink: 0;
  border-right: 1px solid #E5E5E780;
}

/* Content row: avatar + meta, padded 16px from left, vertically centered */
.scl--cms-content-edit-product-upload-preview-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  width: 100%;
  height: 75px;
  background: #FFFFFF;
  box-sizing: border-box;
  margin-right: 20px;
  border-radius: 8px;
  border: 1px dashed #D0D5DD;
}

/* Avatar box — 40×40, border 0.5px solid #D0D5DD, border-radius 4px
   Empty by default; img inside fills it when API data is present */
.scl--cms-content-edit-product-upload-thumb {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #D0D5DD;
  background: #FFFFFF;
  overflow: hidden;
}

.scl--cms-content-edit-product-upload-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Filename + size stacked, gap: 6px */
.scl--cms-content-edit-product-upload-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  min-width: 0;
}

/* Business icons.png — font-weight 500, 14px, color #323539 */
.scl--cms-content-edit-product-upload-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #323539;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 5 MB of 12MB — font-weight 400, 8px, color #8A8B8F */
.scl--cms-content-edit-product-upload-size {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 22px;
  color: #8A8B8F;
}

/* ── Right panel: ContentFileUpload zone ─────────────────────────────────────── */
.scl--cms-content-edit-product-upload-zone-wrap {
  width: 50%;
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  padding-left: 20px;
}

/* List wrapper */
.scl--cms-content-edit-product-service-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

/* One service item: label row + card, gap:8px */
.scl--cms-content-edit-product-service-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* ── Label row: "Service{N}" + Toggle ─────────────────────────────────────── */
.scl--cms-content-edit-product-service-label-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 20px;
}

/* "Service1" text — color #8A8B8F, 14px regular, flex:1 */
.scl--cms-content-edit-product-service-name {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8A8B8F;
}

/* ── Service card: 943×75px dashed border ─────────────────────────────────── */
.scl--cms-content-edit-product-service-card {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 75px;
  background: #FFFFFF;
  border: 1px dashed #D0D5DD;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  gap: 16px;
}

/* Avatar box — 40×40, border 0.5px solid #D0D5DD, radius 4px */
/* Avatar — rendered as <label> for native keyboard/mouse/touch support */
.scl--cms-content-edit-product-service-avatar {
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 0.5px solid #D0D5DD;
  border-radius: 4px;
  background: #FFFFFF;
  overflow: hidden;
  cursor: pointer;
  display: block; /* <label> needs block to size correctly */
}

.scl--cms-content-edit-product-service-avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Hover / focus-within overlay — dark tint, hidden by default */
.scl--cms-content-edit-product-service-avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Show tint on hover or keyboard focus */
.scl--cms-content-edit-product-service-avatar:hover
  .scl--cms-content-edit-product-service-avatar-overlay,
.scl--cms-content-edit-product-service-avatar:focus-within
  .scl--cms-content-edit-product-service-avatar-overlay {
  opacity: 0.3;
}

/* Upload arrow SVG — hidden by default */
.scl--cms-content-edit-product-service-avatar-upload-icon {
  position: absolute;
  left: 37.5%;
  top: 35%;
  width: 25%;
  height: 27.5%;
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
  z-index: 2;
}

/* Show arrow on hover or keyboard focus */
.scl--cms-content-edit-product-service-avatar:hover
  .scl--cms-content-edit-product-service-avatar-upload-icon,
.scl--cms-content-edit-product-service-avatar:focus-within
  .scl--cms-content-edit-product-service-avatar-upload-icon {
  opacity: 1;
}

/* Hidden file input — <label> activates it natively */
.scl--cms-content-edit-product-service-avatar-input {
  display: none;
}

/* Meta: icon name + size stacked, gap:6px */
.scl--cms-content-edit-product-service-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

/* Icon name — 500 / 14px / #323539 */
.scl--cms-content-edit-product-service-icon-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #323539;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* "5 MB of 12MB" — 400 / 8px / #8A8B8F */
.scl--cms-content-edit-product-service-size {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 22px;
  color: #8A8B8F;
}

/* TextField slot — fixed 219px wide, right-aligned per Figma */
.scl--cms-content-edit-product-service-input {
  flex-shrink: 0;
  width: 219px;
}

.scl--cms-content-edit-product-service-input .scl--cms-components-textField-container {
  width: 219px;
}

/* ─── Footer actions ────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 24px;
}

.scl--cms-content-edit-product-section-heading-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/edit-content/product-page/css/contentSectionEditPageProduct.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF,iFAAiF;AACjF;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,mEAAmE;AACrE;AACA,iDAAiD,YAAY,EAAE,YAAY,EAAE;AAC7E,iDAAiD,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACjG,iDAAiD,YAAY,EAAE,WAAW,EAAE;;AAE5E,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;AACA,6CAA6C,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC3G,6CAA6C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEhG,kFAAkF;AAClF;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,iDAAiD;AACjD,4DAA4D,cAAc,EAAE;;AAE5E,kFAAkF;AAClF;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA,0CAA0C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC7F,0CAA0C,cAAc,EAAE;;AAE1D,kFAAkF;AAClF;;;;CAIC;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,YAAY;AACd;;AAEA,4DAA4D;AAC5D;;EAEE,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,YAAY;AACd;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,gEAAgE;AAChE;;EAEE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,YAAY;AACd;;AAEA,kDAAkD;AAClD;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,mFAAmF;AACnF;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;AACnC;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;mEACmE;AACnE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mFAAmF;AACnF;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,OAAO;EACP,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,+DAA+D;AAC/D,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,0CAA0C;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;;;;EAIE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;;;;EAIE,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["/* ContentSectionEditPageProduct.css\n   ─────────────────────────────────────────────────────────────────────────────\n   Scoped with scl--cms-content-edit-product- prefix to avoid collision with the generic cse- page.\n   ───────────────────────────────────────────────────────────────────────────── */\n\n/* ─── Root ─────────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-root {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ─── Skeleton loading ──────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 24px;\n}\n\n@keyframes scl--cms-content-edit-product-shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position:   0% 50%; }\n}\n\n.scl--cms-content-edit-product-skeleton {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);\n  background-size: 400% 100%;\n  animation: scl--cms-content-edit-product-shimmer 1.4s ease infinite;\n}\n.scl--cms-content-edit-product-skeleton--title { height: 40px; width: 280px; }\n.scl--cms-content-edit-product-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }\n.scl--cms-content-edit-product-skeleton--field { height: 44px; width: 100%; }\n\n/* ─── Empty state ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 8px;\n  text-align: center;\n}\n.scl--cms-content-edit-product-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }\n.scl--cms-content-edit-product-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }\n\n/* ─── Page heading ──────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-page-title {\n  margin: 0 0 6px;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 40px;\n  color: #323539;\n}\n.scl--cms-content-edit-product-page-desc {\n  margin: 0 0 28px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #8A8B8F;\n  letter-spacing: -0.01em;\n}\n\n/* ─── Meta grid (Section ID / Author / Section / Title / Status) ────────────── */\n.scl--cms-content-edit-product-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 24px;\n  margin-bottom: 32px;\n}\n/* Status is 5th child — keep it in left column */\n.scl--cms-content-edit-product-meta-grid > *:nth-child(5) { grid-column: 1; }\n\n/* ─── Section editor wrapper ────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-section-editor {\n  overflow: visible;\n  position: relative;\n}\n\n.scl--cms-content-edit-product-section-heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #323539;\n  margin: 0 0 10px;\n}\n\n.scl--cms-content-edit-product-divider {\n  height: 1px;\n  background: #E1E4ED;\n  margin-bottom: 20px;\n}\n\n/* ─── Field label row ───────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.scl--cms-content-edit-product-label    { font-size: 14px; color: #323539; font-weight: 400; }\n.scl--cms-content-edit-product-required { color: #FF4D4F; }\n\n/* ─── SplitRow ──────────────────────────────────────────────────────────────── */\n/*\n  ┌─────────────────────────────────────────────────────────────┐\n  │ ▌  saved / current text (left)   │  [input slot] (right)    │\n  └─────────────────────────────────────────────────────────────┘\n*/\n.scl--cms-content-edit-product-split-row {\n  box-sizing: border-box;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 60px;\n  background: #FDFDFD;\n  border: 1px dashed rgba(208, 213, 221, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.scl--cms-content-edit-product-split-row--multiline {\n  min-height: 96px;\n  align-items: flex-start;\n}\n\n/* Green left accent bar */\n.scl--cms-content-edit-product-split-accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #84A578;\n  border-radius: 0 0 2px 2px;\n  align-self: stretch;\n}\n\n/* Row body */\n.scl--cms-content-edit-product-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px 10px 16px;\n  gap: 12px;\n  min-height: 60px;\n}\n\n.scl--cms-content-edit-product-split-row--multiline .scl--cms-content-edit-product-split-body {\n  align-items: flex-start;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  min-height: 96px;\n}\n\n/* Current / saved value — left side */\n.scl--cms-content-edit-product-split-current {\n  flex: 1;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8);\n  word-break: break-word;\n}\n\n/* Input component slot — right side */\n.scl--cms-content-edit-product-split-slot {\n  flex-shrink: 0;\n  width: 240px;\n}\n\n/* TextField / TextArea component containers fill the slot */\n.scl--cms-content-edit-product-split-slot .scl--cms-components-textField-container,\n.scl--cms-content-edit-product-split-slot .scl--cms-components-textArea-container {\n  width: 100%;\n}\n\n/* Textarea slot — fixed 351px width, scrollable */\n.scl--cms-content-edit-product-split-slot--textarea {\n  width: 351px;\n}\n.scl--cms-content-edit-product-split-slot--textarea .scl--cms-components-textArea-container,\n.scl--cms-content-edit-product-split-slot--textarea .scl--cms-components-textArea-plate,\n.scl--cms-content-edit-product-split-slot--textarea textarea {\n  box-sizing: border-box;\n}\n.scl--cms-content-edit-product-split-slot--textarea textarea {\n  max-height: 96px;\n  overflow-y: auto;\n  resize: none;\n}\n\n/* ─── Card / Product selector row ───────────────────────────────────────────── */\n.scl--cms-content-edit-product-card-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n  margin-top: 16px;\n  margin-bottom: 12px;\n  gap: 12px;\n}\n\n/* Label on the left — takes remaining space */\n.scl--cms-content-edit-product-card-row > .scl--cms-content-edit-product-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-content-edit-product-card-row-right {\n  display: flex;\n  align-items: center; /* <-- vertical alignment */\n  gap: 10px;\n  flex-shrink: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n}\n\n/* SelectField — fixed width so it doesn't push the Toggle off */\n.scl--cms-content-edit-product-card-select,\n.scl--cms-content-edit-product-card-select .scl--cms-components-selectFieldInline-container {\n  width: 220px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n/* Toggle — never shrinks, always visible */\n.scl--cms-content-edit-product-card-row-right > *:last-child {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n/* SelectField dropdown renders above everything */\n.scl--cms-content-edit-product-card-select .scl--cms-components-selectFieldInline-dropdown,\n.scl--cms-content-edit-product-card-select [class*=\"dropdown\"],\n.scl--cms-content-edit-product-card-select [class*=\"menu\"] {\n  z-index: 9999;\n  position: absolute;\n}\n\n.scl--cms-content-edit-product-upload-block {\n  margin-bottom: 4px;\n}\n\n/* Outer container — single dashed border, space-between, vertical divider via ::after */\n.scl--cms-content-edit-product-upload-row {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  min-height: 128px;\n  box-sizing: border-box;\n  background: transparent;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* Vertical divider line drawn at the center */\n.scl--cms-content-edit-product-upload-row::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 100%;\n  background: rgba(229, 229, 231, 0.5);\n  pointer-events: none;\n}\n\n/* ── Left panel: file preview ────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-upload-preview {\n  box-sizing: border-box;\n  position: relative;\n  width: 50%;\n  display: flex;\n  align-items: flex-start;\n  background: transparent;\n  flex-shrink: 0;\n  border-right: 1px solid #E5E5E780;\n}\n\n/* Content row: avatar + meta, padded 16px from left, vertically centered */\n.scl--cms-content-edit-product-upload-preview-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 0 16px;\n  width: 100%;\n  height: 75px;\n  background: #FFFFFF;\n  box-sizing: border-box;\n  margin-right: 20px;\n  border-radius: 8px;\n  border: 1px dashed #D0D5DD;\n}\n\n/* Avatar box — 40×40, border 0.5px solid #D0D5DD, border-radius 4px\n   Empty by default; img inside fills it when API data is present */\n.scl--cms-content-edit-product-upload-thumb {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #D0D5DD;\n  background: #FFFFFF;\n  overflow: hidden;\n}\n\n.scl--cms-content-edit-product-upload-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Filename + size stacked, gap: 6px */\n.scl--cms-content-edit-product-upload-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n/* Business icons.png — font-weight 500, 14px, color #323539 */\n.scl--cms-content-edit-product-upload-name {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #323539;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 5 MB of 12MB — font-weight 400, 8px, color #8A8B8F */\n.scl--cms-content-edit-product-upload-size {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 22px;\n  color: #8A8B8F;\n}\n\n/* ── Right panel: ContentFileUpload zone ─────────────────────────────────────── */\n.scl--cms-content-edit-product-upload-zone-wrap {\n  width: 50%;\n  display: flex;\n  align-items: stretch;\n  flex-shrink: 0;\n  padding-left: 20px;\n}\n\n/* List wrapper */\n.scl--cms-content-edit-product-service-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n/* One service item: label row + card, gap:8px */\n.scl--cms-content-edit-product-service-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n/* ── Label row: \"Service{N}\" + Toggle ─────────────────────────────────────── */\n.scl--cms-content-edit-product-service-label-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  height: 20px;\n}\n\n/* \"Service1\" text — color #8A8B8F, 14px regular, flex:1 */\n.scl--cms-content-edit-product-service-name {\n  flex: 1;\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8A8B8F;\n}\n\n/* ── Service card: 943×75px dashed border ─────────────────────────────────── */\n.scl--cms-content-edit-product-service-card {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 75px;\n  background: #FFFFFF;\n  border: 1px dashed #D0D5DD;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 16px;\n  gap: 16px;\n}\n\n/* Avatar box — 40×40, border 0.5px solid #D0D5DD, radius 4px */\n/* Avatar — rendered as <label> for native keyboard/mouse/touch support */\n.scl--cms-content-edit-product-service-avatar {\n  position: relative;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border: 0.5px solid #D0D5DD;\n  border-radius: 4px;\n  background: #FFFFFF;\n  overflow: hidden;\n  cursor: pointer;\n  display: block; /* <label> needs block to size correctly */\n}\n\n.scl--cms-content-edit-product-service-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Hover / focus-within overlay — dark tint, hidden by default */\n.scl--cms-content-edit-product-service-avatar-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Show tint on hover or keyboard focus */\n.scl--cms-content-edit-product-service-avatar:hover\n  .scl--cms-content-edit-product-service-avatar-overlay,\n.scl--cms-content-edit-product-service-avatar:focus-within\n  .scl--cms-content-edit-product-service-avatar-overlay {\n  opacity: 0.3;\n}\n\n/* Upload arrow SVG — hidden by default */\n.scl--cms-content-edit-product-service-avatar-upload-icon {\n  position: absolute;\n  left: 37.5%;\n  top: 35%;\n  width: 25%;\n  height: 27.5%;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* Show arrow on hover or keyboard focus */\n.scl--cms-content-edit-product-service-avatar:hover\n  .scl--cms-content-edit-product-service-avatar-upload-icon,\n.scl--cms-content-edit-product-service-avatar:focus-within\n  .scl--cms-content-edit-product-service-avatar-upload-icon {\n  opacity: 1;\n}\n\n/* Hidden file input — <label> activates it natively */\n.scl--cms-content-edit-product-service-avatar-input {\n  display: none;\n}\n\n/* Meta: icon name + size stacked, gap:6px */\n.scl--cms-content-edit-product-service-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Icon name — 500 / 14px / #323539 */\n.scl--cms-content-edit-product-service-icon-name {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #323539;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* \"5 MB of 12MB\" — 400 / 8px / #8A8B8F */\n.scl--cms-content-edit-product-service-size {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 22px;\n  color: #8A8B8F;\n}\n\n/* TextField slot — fixed 219px wide, right-aligned per Figma */\n.scl--cms-content-edit-product-service-input {\n  flex-shrink: 0;\n  width: 219px;\n}\n\n.scl--cms-content-edit-product-service-input .scl--cms-components-textField-container {\n  width: 219px;\n}\n\n/* ─── Footer actions ────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 24px;\n}\n\n.scl--cms-content-edit-product-section-heading-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
